import { t } from '@/shared/i18n/t';
import { tn } from '@/shared/i18n/tn';

type SummaryCounts = {
  readonly loading: boolean;
  readonly attention: number;
  readonly overdue: number;
  readonly low: number;
};

export function dashboardSummary({ loading, attention, overdue, low }: SummaryCounts): string {
  if (loading) return ' ';
  if (attention === 0 && low === 0) return t('All in order.');
  const soon = attention - overdue;
  const parts = [
    overdue > 0 ? tn(overdue, '{count} late', '{count} late') : null,
    soon > 0 ? tn(soon, '{count} due soon', '{count} due soon') : null,
    low > 0 ? tn(low, '{count} low on stock', '{count} low on stock') : null,
  ];
  return parts.filter(Boolean).join(' · ');
}
